import $ from 'jquery';

class BootstrapSelectCompatability {
    constructor() {

    }

    init() {
        this.bindEvents();             
    }

    bindEvents() {
        // boostrap 4 version of bootstrap select toggles show class on the bootstrap-select
        // events found here
        // https://developer.snapappointments.com/bootstrap-select/options/#events

        let select = $('.bootstrap-select select');        
        select.on('show.bs.select', (e, clickedIndex, isSelected, previousValue) => {
            let parent = e.currentTarget.closest('.bootstrap-select');
            $(parent).addClass('show');
        }); 
        select.on('hide.bs.select', (e, clickedIndex, isSelected, previousValue) => {
            let parent = e.currentTarget.closest('.bootstrap-select');
            $(parent).removeClass('show');
        }); 
    }
}

export default BootstrapSelectCompatability;